<template>
  <div class="tuolele-main-box set-combo">
    <div class="tuolele-main-search">
      <el-button type="success" @click="fnCreateActive()">创建活动</el-button>
    </div>
    <div class="tuolele-main-content">
      <el-table :data="activeLists" border>
        <el-table-column prop="id" label="活动ID" />
        <el-table-column prop="title" label="活动名称" />
        <el-table-column prop="begin_time" label="开始时间" />
        <el-table-column prop="end_time" label="结束时间" />
        <el-table-column label="操作" width="210">
          <template slot-scope="scope">
            <el-button type="success" size="mini" @click="popSetInfo(scope.row.id)">编辑</el-button>
            <el-dropdown size="mini" style="margin-left:10px">
              <el-button type="primary" size="mini">
                更多操作<i class="el-icon-arrow-down el-icon--right" />
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="fnSetAward(scope.row.id)">修改奖品</el-dropdown-item>
                <el-dropdown-item @click.native="fnSetUser(scope.row.id)">抽奖用户设置</el-dropdown-item>
                <el-dropdown-item @click.native="fnCorrectLists(scope.row.id)">中奖记录</el-dropdown-item>

              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <div class="footer pagination-footer">
        <div class="block">
          <el-pagination
            layout="prev, pager, next, slot, jumper"
            :current-page.sync="listQuery.p"
            prev-text="上一页"
            next-text="下一页"
            :total="listQuery.total"
            :page-size="listQuery.limit"
            @current-change="fnGetLists"
          />
        </div>
      </div>
      <el-dialog :key="'create'+dialogKey" title="新增活动" :visible.sync="dialogVisible" width="600px">
        <el-form ref="postForm" :model="postForm" :rules="rules">
          <el-form-item label="活动名称" prop="title">
            <el-input v-model="postForm.title" style="width: 400px;" placeholder="请输入内容" />
          </el-form-item>
          <el-form-item label="开始时间" prop="begin_time">
            <el-date-picker v-model="postForm.begin_time" value-format="yyyy-MM-dd HH:mm" type="datetime" placeholder="选择日期" />
          </el-form-item>
          <el-form-item label="结束时间" prop="end_time">
            <el-date-picker v-model="postForm.end_time" value-format="yyyy-MM-dd HH:mm" type="datetime" placeholder="选择日期" />
          </el-form-item>
          <el-form-item label="不适用说明" prop="inconformity">
            <el-input v-model="postForm.inconformity" type="textarea" :rows="3" placeholder="请输入内容" />
          </el-form-item>
          <el-form-item label="抽奖规则" prop="rule_content">
            <el-input v-model="postForm.rule_content" type="textarea" :rows="3" placeholder="请输入内容" />
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="fnSubmit">确定</el-button>
        </span>
      </el-dialog>
      <el-dialog title="导入学生" :visible.sync="dialogImprove" width="600px">
        <improve-active-student :key="improveKey" :activity-id="postForm.id" @successCBK="fnGetLists()" />
      </el-dialog>
      <el-dialog title="修改信息" :visible.sync="dialogSetInfo" width="600px">
        <set-active-info :key="setKey" :last-data="acitvieLastData" :type="setType" :activity-id="postForm.id" @successCBK="fnGetLists()" />
      </el-dialog>
    </div>
  </div>
</template>
<script>

import Tool from '@/assets/js/tool.js'
import { validateRequire } from '@/utils/validate'
import improveActiveStudent from './components/ImpoveActiveStudent'
import setActiveInfo from './components/SetActiveInfo'

const defaultPostForm = {
  id: '',
  begin_time: '',
  title: '',
  end_time: '',
  inconformity: '',
  rule_content: ''
}

export default {
  name: 'StoreSetting',
  components: {
    improveActiveStudent,
    setActiveInfo
  },
  data() {
    return {
      dialogVisible: false,
      dialogImprove: false,
      dialogSetInfo: false,
      dialogSetAward: false,
      dialogKey: 0,
      setType: 'date',
      acitvieLastData: '',
      improveKey: 999,
      setKey: 9999,
      listQuery: {
        total: 0,
        p: 1,
        limit: 20
      },
      postForm: Object.assign({}, defaultPostForm),
      activeLists: [],
      rules: {
        begin_time: [{ validator: validateRequire, trigger: 'manual', message: '开始时间' }],
        end_time: [{ validator: validateRequire, trigger: 'manual', message: '结束时间' }],
        title: [{ validator: validateRequire, trigger: 'manual', message: '名称' }],
        inconformity: [{ validator: validateRequire, trigger: 'manual', message: '不适用说明' }],
        rule_content: [{ validator: validateRequire, trigger: 'manual', message: '抽奖规则' }]
      }
    }
  },
  mounted() {
    this.fnGetLists()
  },
  methods: {
    fnGetLists() {
      this.dialogImprove = false
      this.dialogVisible = false
      this.dialogSetInfo = false
      this.$http.getActivityLuckyList(this.listQuery).then(res => {
        this.listQuery.total = parseInt(res.data.count)
        this.activeLists = res.data.list
      })
    },
    fnCreateActive() {
      this.postForm = Object.assign({}, defaultPostForm)
      this.dialogVisible = true
    },
    fnSetAward(lottery_id) {
      this.$router.push({
        path: 'activeAwardLists',
        query: { id: lottery_id }
      })
    },
    fnDelete(project_id) {
      this.$confirm('是否删除质检项目?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.delProject({ project_id }).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功'
          })
          this.fnGetLists()
        })
      })
    },
    fnSetUser(id) {
      this.$router.push({
        path: 'activeLuckyStudentLists',
        query: { id: id }
      })
    },
    fnCorrectLists(id) {
      this.$router.push({
        path: 'activeLuckyCorrectLists',
        query: { id: id }
      })
    },
    popImprove(id) {
      this.postForm.id = id
      this.improveKey++
      this.dialogImprove = true
    },
    popSetInfo(id) {
      this.$http.getLuckyActivityInfo({ id }).then((res) => {
        this.postForm = Object.assign({}, res.data)
        this.dialogKey++
        this.dialogVisible = true
      })
    },
    fnCreateProject(projectId) {
      this.postForm = Object.assign({}, defaultPostForm)
      this.dialogVisible = true
    },
    fnSubmit() {
      this.$refs.postForm.validate(valid => {
        if (valid) {
          this.$http.improveLucyActivity(this.postForm).then(res => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: '添加成功'
              })

              this.dialogVisible = false
              this.fnGetLists()
            }
          })
        }
      })
    }
  }
}
</script>
<style lang="scss">
  .wq_flex {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
}

.wq_flex_wrap {
  flex-wrap: wrap;
}

.wq_flex_sub {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
}

.set-combo {
  .self-table {
    margin-top: 0 !important;
  }
  .el-form-item__label {
    font-size: 16px;
    color: #333;
  }
  .el-form-item__content {
    margin: 0 20px 0 12px;
  }
  .el-button.el-button-confirm {
    width: 80px !important;
  }
}
</style>
